exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hd-lab[data-v-7eed8536]{background-color:#fae3d3;border-left:3px solid #e67323}.hd-lab .lab-txt[data-v-7eed8536]{color:#e67323}", ""]);

// exports
